import { PeekTypography } from "@piiqtechnologies/ui-components";
import { ChevronDown, ChevronUp } from "@piiqtechnologies/svg-icons";
import React from "react";
export const ArrowDrop = (props) => {
    return (React.createElement(PeekTypography, { alignItems: "end", color: (props.active && "secondary") || "primary", sx: { mx: 0.5, mt: 0.5 } }, (props.direction === "desc" && React.createElement(ChevronDown, null)) || React.createElement(ChevronUp, null)));
};
